import { Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { CustomQuillBase } from './../custom-quill-base-class';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';

interface ClickFlag {
  embed: boolean;
  video: boolean;
}

@Component({
  selector: 'unh-comment-quill-editor',
  templateUrl: './comment-quill-editor.component.html',
  styleUrls: ['./comment-quill-editor.component.scss']
})

export class CommentQuillEditorComponent extends CustomQuillBase implements OnInit {
  @ViewChild('inputRef') inputRef: ElementRef;

  destroy$ = new Subject<boolean>();
  ngOnInit() {
    this.imageQuillDTO.pipe(
      tap(images => {
        this.onImagesChanged.emit(images);
      }),
      takeUntil(this.destroy$)
    ).subscribe();
  }
  ngOnDestroy() {
    this.destroy$.next(true);
  }
}
